import AppModal from '@/shared/components/shared/AppModal'
import OnClickOutside from '@/shared/components/shared/OnClickOutside'

// Shared filters
import Currency from '@/shared/filters/Currency'

export default {
  install (Vue, _options) { // eslint-disable-line no-unused-vars
    Vue.component('AppModal', AppModal)
    Vue.component('OnClickOutside', OnClickOutside)

    Vue.filter('currency', Currency)
  }
}
